webpackJsonp([97780725575214],{

/***/ 96:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var icon1 = "https://winpeleadershipsummit.winpeforum.com/wp-content/uploads/2021/12/Picture1aa.jpg";
	var icon2 = "https://winpeforum.com/assets/elements/ZiaMody_edit.jpg";
	var icon4 = "https://winpeforum.com/assets/elements/Renuka-Ramnath.png";
	var icon3 = "https://winpeforum.com/assets/elements/CDPQ_mem1.jpg";
	var icon5 = "https://winpeforum.com/assets/elements/esterNew.jpg";
	var icon6 = "https://winpeforum.com/assets/elements/matangi.jpg";
	var icon7 = "https://winpeforum.com/assets/elements/shyamala.jpg";
	var icon8 = "https://www.winpeforum.com/assets/elements/shanti.jpg";
	var icon9 = "https://www.winpeforum.com/assets/elements/DeepakKapoor.png";
	var icon10 = "https://www.winpeforum.com/assets/elements/mdamodaran.jpg";
	var icon11 = "https://www.winpeforum.com/assets/elements/NainaLal.png";
	var iconnewteam1 = "https://winpeforum.com/assets/elements/TinaAhluwalia.jpg";
	var iconnewteam2 = "https://winpeforum.com/assets/elements/AyushiVedwan.png";
	var iconnewteam3 = "https://winpeforum.com/assets/elements/PalakPatel.jpg";
	var iconnewteam4 = "https://winpeforum.com/assets/elements/VijaytaMahendru.png";
	var iconnewteam5 = "https://winpeforum.com/assets/elements/SudhanshuKhurana.jpg";
	var iconnewteam6 = "https://winpeforum.com/assets/elements/PrernaJain.jpg";
	var iconnewteam7 = "https://winpeforum.com/assets/elements/Purnima.png";
	var iconnewteam8 = "https://winpeforum.com/assets/elements/DeekshaJain.png";
	var iconnewamb1 = "https://winpeforum.com/assets/ambassadors/KaushalyaVenkataraman.png";
	var iconnewamb2 = "https://winpeforum.com/assets/ambassadors/PratitiDasgupta.png";
	var iconnewamb3 = "https://winpeforum.com/assets/ambassadors/NupurNataraja.png";
	var iconnewamb5 = "https://winpeforum.com/assets/ambassadors/SheetalTrivedi.png";
	var iconnewamb4 = "https://winpeforum.com/assets/ambassadors/KanakHeda.png";
	var iconnewamb6 = "https://winpeforum.com/assets/ambassadors/CheshtaVashishth.png";
	
	var team_constants = [{
	  imgUrl: icon3,
	  // into:"Anita M. George is Executive Vice-President and Deputy Head of CDPQ Global. She fills a key role in developing CDPQ’s activities in its three priority international areas: the United States/Latin America, Europe and Asia Pacific. She actively participates in positioning CDPQ internationally, as well as developing and executing its globalization strategy.",
	  desc: "<div>Anita has been an investor backing early trends with winning partners and established a distinguished track record in sustainable investments across the globe. In her last five and a half years with CDPQ, she established CDPQ's office in India and soon after became Executive Vice President and Head of Emerging Markets at CDPQ. Her final post at CDPQ was as Executive Vice President and Deputy Head of CDPQ Global covering all geographies outside of Canada, supporting investments in renewable energy, highways, telecom, and venture fund investments in Emerging Markets. Anita spent 22 years at the World Bank Group with 14 of those years with the IFC in Infrastructure and Natural Resources, Municipal Finance and initiated the creation of IFC's Venture group. Her various roles have led her to work in several regions of the world, including Europe, Asia, the Middle East, Africa and Latin America.\n   <br/><Br/>\n    Ms. George holds a BA in Economics and Spanish from Smith College, in Massachusetts, and a Masters in Economics and an MBA in Finance from Boston University.\n\t\t\t\t</div>",
	  name: "Anita George",
	  post: "<div>Member, Advisory Board, Winpe<br/>Global Sustainable Investment Professional</div>",
	  link: "https://www.linkedin.com/in/anita-george-255778133/"
	}, {
	  imgUrl: icon9,
	  // into:"Renuka Ramnath is the Founder, Managing Director and CEO of Multiples Alternate Asset Management, a private equity manager and advisor to funds of ~ USD 1.5 bn. She has over 30 years of experience in the Indian financial sector across private equity, investment banking and structured finance.",
	  desc: "",
	  name: "Deepak Kapoor",
	  post: "<div>Member, Advisory Board, Winpe Women on Boards<br/>Former Chairman & CEO, PwC India</div>",
	  link: "https://www.linkedin.com/in/deepak-kapoor-aa4a531/"
	}, {
	  imgUrl: icon6,
	  // into:"Zia J. Mody, Co–Founder and Managing Partner of AZB & Partners, is one of India’s foremost corporate attorneys. Zia is widely acknowledged for her expertise, ranking No. 1 in Fortune India’s ‘India’s 50 Most Powerful Women in Business’ list in 2018 & 2019, on which she has consistently ranked in the top 10 since 2011.",
	  name: "Matangi Gowrishankar",
	  desc: "<div>Ms. Matangi Gowrishankar brings more than three decades of experience as a business, Human Resources and Change Management specialist. Passionate about leadership and organization development she has a track record in organization transformation and talent management both in India and overseas.\n\t\t<br />\n\t\t<br />\n\t\tShe has worked with several large multinational organizations like Standard Chartered Bank, Reebok, GE, Cummins Inc and most recently, with the British Oil Major BP plc where her last assignment was Global Head of Capability Development and Director of the Leadership Academy. She has extensive, diverse experience having lived and worked in the UK and Singapore with a broad geographical remit across several countries.\n\t\t<br />\n\t\t<br />\n\t\tMs. Gowrishankar has a BA in Sociology and a Post Graduate qualification in Human Resources from XLRI, a premier educational institution in India. She is a certified coach from the Neuroleadership Group (previously Results Coaching) Australia. Ms. Gowrishankar also holds certifications from SHL (Saville & Holdsworth) for designing and conduct of Assessment Centres, Instructional Design and Facilitation Skills from Skill Base UK.\n\t\t<br />\n\t\t<br />\n\t\tToday, with an independent organization development practice, Ms. Gowrishankar continues to work with BP and other organizations coaching, guiding and facilitating leaders to transform self and the organization to meet the challenges of doing business in a highly volatile and dynamic environment. She has experience in leading several D&I initiatives including highly successful development offers for women both in India and overseas. Her credo is to make a positive difference to individuals and organizations. She believes in enduring partnerships built on trust and mutual respect. She is committed to leveraging diversity of thought and the human spirit for achieving the best outcomes.\n\t\t<br />\n\t\t<br />\n\t\tMs. Gowrishankar also holds Non - Executive Independent Directorships with 8 companies in India across diverse industries.\n\t\t<br />\n\t\t<br />\n\t\tShe has been a regular speaker at Indian and global conferences and has contributed to several case study commentaries in Indian business magazines.\n\t\t<br />\n\t\t<br />\n\t\tMs. Gowrishankar and her mother live in Pune, India. Her son, an event management specialist lives in Melbourne, Australia.\n\t\t</div>",
	  post: "<div>Member, Advisory Board, Winpe Proclub <br /> Independent Director, Strategic Advisor & Certified Coach</div>",
	  link: "https://www.linkedin.com/in/matangi-gowrishankar-0814a74/"
	}, {
	  imgUrl: icon10,
	  // into:"Renuka Ramnath is the Founder, Managing Director and CEO of Multiples Alternate Asset Management, a private equity manager and advisor to funds of ~ USD 1.5 bn. She has over 30 years of experience in the Indian financial sector across private equity, investment banking and structured finance.",
	  desc: "",
	  name: "M Damodaran",
	  post: "<div>Member, Advisory Board, Winpe Women on Boards<br/>Chairperson, Excellence Enablers<br/> Former Chairperson, SEBI</div>",
	  link: "https://www.linkedin.com/in/m-damodaran-7ab36a194/"
	}, {
	  imgUrl: icon11,
	  // into:"Renuka Ramnath is the Founder, Managing Director and CEO of Multiples Alternate Asset Management, a private equity manager and advisor to funds of ~ USD 1.5 bn. She has over 30 years of experience in the Indian financial sector across private equity, investment banking and structured finance.",
	  desc: "",
	  name: "Naina Lal Kidwai",
	  post: "<div>Member, Advisory Board, Winpe Women on Boards<br/>Padma Shree Awardee<br/>Former Chairperson, HSBC Group</div>",
	  link: "https://www.linkedin.com/in/naina-lal-kidwai/"
	}, {
	  imgUrl: icon4,
	  // into:"Renuka Ramnath is the Founder, Managing Director and CEO of Multiples Alternate Asset Management, a private equity manager and advisor to funds of ~ USD 1.5 bn. She has over 30 years of experience in the Indian financial sector across private equity, investment banking and structured finance.",
	  desc: "<div>Renuka Ramnath is the Founder, Managing Director and CEO of Multiples Alternate Asset Management, a private equity manager and advisor to funds of ~ USD 1.5 bn. She has over 30 years of experience in the Indian financial sector across private equity, investment banking and structured finance. \n\t\t<br />\n\t\t<br />\n\t\tFor close to three decades in financial services, Renuka successfully built several businesses in the ICICI Group including Investment Banking, e-commerce and private equity. As the MD & CEO of ICICI Venture for close to a decade, she led that firm to become one of the largest private equity funds in India.\n\t\t<br />\n\t\t<br />\n\t\tShe is a Board member of EMPEA, the global industry association for private capital in emerging markets. She is also the Chairperson of the Executive Committee of  Indian Venture Capital Association.  Renuka has been featured in many prestigious listings, including the Top 25 Most Powerful Women in Business (Business Today, India); India's most Powerful CEO's (Economic Times), the Top 25 Non Bank Women in Finance (US Banker's global list), Asia's Women in the Mix: The Year's Top 50 for Achievement in Business (Forbes), Top 25 women in Asian asset management (Asian Investor) and most recently has been awarded the AVCJ Special Achievement Award, 2019.\n\t\t</div>",
	  name: "Renuka Ramnath",
	  post: "<div>Member, Advisory Board, Winpe <br /> Founder, MD & CEO, Multiples Alternate Asset Management</div>",
	  link: "https://www.linkedin.com/in/renukaramnath/"
	}, {
	  imgUrl: icon8,
	  desc: "<div>Shanti Ekambaram is a distinguished banking business and governance leader with 39 years of financial services experience, including an exceptional 35-year tenure at Kotak Mahindra Bank where she was a part of the team that shaped the institution's transformation from a pre- IPO non-banking financial company to one of India's most respected universal banks. Her career exemplifies the rare combination of, strategic vision, deep business orientation, operational expertise and governance acumen that modern boards seek in their directors.<br /><br />\n\nMost recently serving as Deputy Managing Director and Whole-time Director (2022-2025), Shanti provided strategic oversight across Treasury, Balance Sheet Management, Digital Banking (811), Human Resources, Internal Audit, Vigilance, CSR/ESG, and Kotak's capital market subsidiaries. In this role, she chaired the First Tier Audit Committee and POSH Committee, demonstrating her commitment to financial integrity, regulatory compliance, and organizational culture. Her stewardship during this period guided the Bank through external markets volatility and regulatory transitions while delivering stakeholder value.<br /><br />\n\nShanti's career is distinguished by her institution-building capabilities across multiple business verticals and she has a unique blend of Corporate, Retail and Digital business experience.. As President of Consumer Banking (2014-2022), she led the strategic transformation of the division through India's largest same-size bank merger\u2014the integration of ING Vysya Bank\u2014 while simultaneously pioneering digital banking innovation. The launch of 811 in March 2017, India's first Aadhaar-enabled, zero-balance digital banking platform, required unprecedented collaboration with regulators including RBI and UIDAI, establishing new paradigms for digital onboarding that have since become industry standard. Her ability to navigate the regulatory disruption of demonetization (November 2016) and position the Bank for accelerated digital adoption demonstrated strategic agility and crisis leadership.<br /><br />\n\nEarlier, as President of Wholesale Banking (2003-2014), Shanti architected the business from inception following Kotak's banking license acquisition. She established comprehensive governance frameworks, risk policies, and compliance infrastructure across corporate banking, SME, financial institutions, debt capital markets, custody, and transaction banking. Her leadership during the 2008 global financial crisis\u2014navigating through the Lehman Brothers collapse with zero credit stress\u2014validated her conservative risk philosophy and , protecting shareholder value during one of history's most turbulent financial periods.<br /><br />\n\nPerhaps most significantly for India's capital markets, Shanti served as CEO of Kotak Mahindra Capital Company (1997-2003), the investment banking joint venture with Goldman Sachs. She led a team that pioneered the transformation of India's equity capital markets by leading the Hughes Software IPO in 1999\u2014the country's first book-building transaction. This landmark achievement required intensive collaboration with SEBI, investors, and market participants to fundamentally reform IPO mechanisms, replacing archaic systems with global standards. The governance frameworks and market practices that were established persist today, demonstrating her capacity to drive systemic change through regulatory partnership and industry leadership.<br /><br />\n\nHer leadership of Kotak's CSR and ESG strategy reflects values-driven decision-making that extends beyond compliance to genuine stakeholder impact.<br /><br />\n\nA Chartered Accountant and Cost and Management Accountant, Shanti brings the business expertise and technical financial expertise and audit committee qualifications that boards require for oversight of complex financial institutions.<br /><br />\n\nShe currently serves on the boards of Kotak Mahindra Capital Company, Kotak Securities, and the Indian Institute of Management, Bangalore, where she contributes strategic direction to India's premier business education institution.<br /><br />\n\nBeyond her professional achievements, Shanti's commitment to ESG and social impact is deeply rooted and authentic. She has been involved at the founder level with SOPAN (Society of Parents of Children with Autistic Disorders), an autism advocacy organization, and consistently fundraises for social causes through her participation in the Mumbai Marathon. Shanti's industry recognition underscores her standing as a preeminent business leader. She was ranked No. 1 on the Candere Hurun India Women Leaders List 2025 and named Businesswoman of the Year 2025 by The CEO Magazine. She has been consistently recognized by Fortune India's '50 Most Powerful Women in Business' and Business Today's 'Most Powerful Women in Indian Business' throughout her career, reflecting sustained excellence and impact.\n<br /><br />\nAs she transitions to board director and strategic advisory roles post-retirement from Kotak Mahindra Bank in October 2025, Shanti seeks opportunities where her extensive governance expertise, financial acumen, regulatory navigation capabilities, and transformational leadership can guide organizations through strategic inflection points.\n<br /><br />\nShanti\u2019s proven ability to build institutions, drive market innovation, navigate crises, and maintain unwavering commitment to governance standards positions her as an exceptional addition to boards seeking directors who combine strategic vision with fiduciary discipline and genuine stakeholder orientation.\n\t\t</div>",
	  name: "Shanti Ekambaram",
	  post: "<div>Member, Advisory Board, Winpe Proclub<br /> Deputy Managing Director & Whole-time Director</div>",
	  link: "https://www.linkedin.com/in/shanti-ekambaram-5993b327/"
	}, {
	  imgUrl: icon2,
	  // into:"Zia J. Mody, Co–Founder and Managing Partner of AZB & Partners, is one of India’s foremost corporate attorneys. Zia is widely acknowledged for her expertise, ranking No. 1 in Fortune India’s ‘India’s 50 Most Powerful Women in Business’ list in 2018 & 2019, on which she has consistently ranked in the top 10 since 2011.",
	  name: "Zia J. Mody",
	  desc: "<div>Zia J. Mody, Co\u2013Founder and Managing Partner of AZB & Partners, is one of India\u2019s foremost corporate attorneys. Zia is widely acknowledged for her expertise, ranking No. 1 in Fortune India\u2019s \u2018India\u2019s 50 Most Powerful Women in Business\u2019 list in 2018 & 2019, on which she has consistently ranked in the top 10 since 2011. \n\t\t<br />\n\t\t<br />\n\t\tZia has held and continues to hold several prestigious positions at global and national levels. She currently serves as a Member, Governing Board \u2013 International Council for Commercial Arbitration (ICCA) and Member \u2013 CII National Council. She was the Vice President & Member \u2013 London Court of International Arbitration (LCIA) and Member \u2013 World Bank Administrative Tribunal, Washington D.C.. In addition, Zia has served in various capacities on several committees and panels set up by Indian regulatory bodies including SEBI, RBI, Law Commission of India and Ministry of Corporate Affairs.\n\t\t<br />\n\t\t<br />\n\t\tZia has been a recipient of numerous awards recognizing her individual and professional achievements as a legal practitioner and leader. She completed her masters in law from the Harvard Law School and is a member of the New York State Bar Association. Zia\u2019s practice areas include Mergers & Acquisitions, Private Equity, Restructuring and General Corporate, Compliance & Investigation, Dispute Resolution, and Regulatory & Securities Law.\n\t\t</div>",
	  post: "<div>Member, Advisory Board, Winpe <br /> Co\u2013Founder & Managing Partner, AZB & Partners</div>",
	  link: "https://www.linkedin.com/in/ziamody"
	}];
	
	var team_constants1 = [{
	  imgUrl: icon1,
	  // into:"Nupur Garg is a leading investor in private equity and venture capital and an expert advisor to large institutional investors. Nupur’s experience spans private equity investing, operations and finance in leading global organizations like IFC – an arm of the World Bank Group, Discovery Networks and PwC.",
	  desc: "<div>Nupur Garg is a leading investor in private equity and venture capital\nand an expert advisor to large institutional investors. She is the\nfounder of Winpe, an initiative to enhance gender diversity in the\ninvesting ecosystem.<br/><br/>\nNupur serves as Chairperson of the board of Kids Clinic India\nLimited (Cloudnine chain of hospitals) and an independent director\non the boards of Edelweiss Real Assets Managers Limited and\nMolbio Diagnostics Limited. She is an advisor to and a member of\nthe investment committee for the Dutch Good Growth Fund\n(DGGF) investment funds mandate given by the Dutch government\nfor investments in SMEs in frontier markets across 75 countries.<br/><br/>\nNupur has served two terms on the board of SIDBI, the Indian DFI,\nas an early member of the investment committee at the Fund of Funds managed by the National\nInvestment and Infrastructure Fund (NIIF), the quasi-sovereign wealth fund sponsored by the government\nof India and on the investment committee for the INR 10,000 crore Fund of Fund for Start-ups for\ninvesting in the Indian start-up ecosystem; guiding the development of their investment programs. Nupur\nadvises select fund managers on a confidential basis on matters related to institutionalization, best practices\nand governance. She also mentors female entrepreneurs across various platforms.<br/><br/>\nNupur is recognized as a thought and industry leader with a list of recognitions that include the Private\nEquity International Most Influential Women (global) 2024, BW VC World Most Influential Women 2024,\n2023 and 2022, HerPower Award 2023, Forbes W-Power list of Self Made Women 2020, India\u2019s top 10\nWomen Leaders in Finance (AIWMI 2019), Vedica Women\u2019s Alliance\u2019s Women Leader in D&I 2022,\nWomen Empowerment Entrepreneur Award 2019-20 and the Business Excellence and Innovative Best\nPractices - Academia Award 2019.<br/><br/>\nIn her previous role, Nupur led the private equity and venture capital funds business in the region for IFC\nand is widely credited with establishing IFC\u2019s brand and credibility as one of the most respected\ninstitutional investors in this space. Under her stewardship, the portfolio doubled in size and returns,\nmoving from a negative IRR to delivering gains for the first time in its history.<br/><br/>\nNupur is a CA and an MBA from MIT Sloan School of Management, with executive education from\nHarvard Business School.<br/><br/>\nNupur loves to spend time with her mother, husband and 10-year-old son, travel to new places, read and\ndo 1500-piece puzzles.\n\t\t\t\t</div>",
	  name: "Nupur Garg",
	  post: "<div>Founder, Winpe <br /> Investor & Independent Director</div>",
	  link: "https://www.linkedin.com/in/nupurgarg/"
	}];
	
	var ambassadors_team_current = [{
	  imgUrl: iconnewamb6,
	  name: "Cheshta Vashishth",
	  desc: "",
	  post: "",
	  designation: "Founder",
	  company: "Uphill Education",
	  link: "https://www.linkedin.com/in/cheshta-vashishth-72597b1ab/"
	}, {
	  imgUrl: iconnewamb4,
	  name: "Kanak Heda",
	  desc: "",
	  post: "",
	  designation: "AVP",
	  company: "Censie Capital Partners",
	  link: "https://www.linkedin.com/in/kanak-heda-882662149/"
	}, {
	  imgUrl: iconnewamb1,
	  name: "Kaushalya Venkataraman",
	  desc: "",
	  post: "",
	  designation: "Partner",
	  company: "Chandhiok & Mahajan",
	  link: "https://www.linkedin.com/in/kaushalyav/"
	}, {
	  imgUrl: iconnewamb3,
	  name: "Nupur Nataraja",
	  desc: "",
	  post: "",
	  designation: "Associate, Asset Management",
	  company: "Virtuous Retail ",
	  link: "https://www.linkedin.com/in/nupur-nataraja-a1b21a16b/"
	}, {
	  imgUrl: iconnewamb2,
	  name: "Pratiti Dasgupta",
	  desc: "",
	  post: "",
	  designation: "Consultant",
	  company: "Avana Capital",
	  link: "https://www.linkedin.com/in/pratiti-dasgupta-bb92671b1/"
	}];
	
	var ambassadors_team_previous = [{
	  imgUrl: iconnewteam2,
	  name: "Ayushi Vedwan",
	  desc: "",
	  post: "",
	  designation: "Lead - Brand Communications & Designing",
	  company: "",
	  link: "https://www.linkedin.com/in/ayushivedwan/"
	}, {
	  imgUrl: iconnewteam8,
	  name: "Deeksha Jain",
	  desc: "",
	  post: "",
	  designation: "Manager Founder's Office",
	  company: "",
	  link: "https://www.linkedin.com/in/deekshajain?utm_source=share_via&utm_content=profile&utm_medium=member_android"
	}, {
	  imgUrl: iconnewteam4,
	  name: "Dr. Vijayta Mahendru",
	  desc: "",
	  post: "",
	  designation: "Manager: Business and Operations",
	  company: "",
	  link: "https://www.linkedin.com/in/vijayta-mahendru-phd-66421797/"
	}, {
	  imgUrl: iconnewteam6,
	  name: "Prerna Jain",
	  desc: "",
	  post: "",
	  designation: "Program Manager",
	  company: "",
	  link: "https://linkedin.com/in/dr-prerna-jain-51519650"
	}, {
	  imgUrl: iconnewteam5,
	  name: "Sudhanshu Khurana",
	  desc: "",
	  post: "",
	  designation: "Operations Associate",
	  company: "",
	  link: "https://www.linkedin.com/in/sudhanshu-khurana-622524194/"
	}, {
	  imgUrl: iconnewteam1,
	  name: "Tina Ahluwalia",
	  desc: "",
	  post: "",
	  designation: "Director- Partnerships & Operations",
	  company: "",
	  link: "https://www.linkedin.com/in/tina-ahluwalia/"
	}];
	
	exports.team_constants = team_constants;
	exports.team_constants1 = team_constants1;
	exports.ambassadors_team_current = ambassadors_team_current;
	exports.ambassadors_team_previous = ambassadors_team_previous;

/***/ }),

/***/ 213:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.ambassadors = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(213);
	
	var _Heading = __webpack_require__(7);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _contentPage = __webpack_require__(4);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(5);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Modal = __webpack_require__(8);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _team_constants = __webpack_require__(96);
	
	__webpack_require__(10);
	
	var _reactAnimateOnScroll = __webpack_require__(11);
	
	var _reactAnimateOnScroll2 = _interopRequireDefault(_reactAnimateOnScroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var duration = 400;
	
	var TeamModal = function TeamModal(_ref) {
	  var activeItem = _ref.activeItem,
	      show = _ref.show,
	      onHide = _ref.onHide;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      direction: "",
	      className: "teamdetails__wrapper",
	      show: show,
	      onHide: onHide
	    },
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "head_section" },
	        _react2.default.createElement(
	          "span",
	          { className: "item_name" },
	          activeItem.name
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "item_des" },
	          activeItem.post
	        )
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "cross pull-right" },
	        _react2.default.createElement("i", { onClick: onHide, className: "fa fa-times" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "item__desc" },
	        _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: activeItem.desc } })
	      )
	    ),
	    _react2.default.createElement(_Modal2.default.Footer, null)
	  );
	};
	TeamModal.propTypes = {
	  activeItem: _propTypes2.default.object,
	  show: _propTypes2.default.object,
	  onHide: _propTypes2.default.object
	};
	
	var ambassadors = exports.ambassadors = function (_React$Component) {
	  _inherits(ambassadors, _React$Component);
	
	  function ambassadors(args) {
	    _classCallCheck(this, ambassadors);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.togglePopUp = function (item) {
	      _this.setState({
	        isShow: !_this.state.isShow,
	        activeItem: item || {}
	      });
	    };
	
	    _this.state = {
	      activeItem: {},
	      isShow: false,
	      defaultStyle: {
	        transition: "opacity " + duration + "ms ease-in-out",
	        opacity: 0
	      }
	    };
	    return _this;
	  }
	
	  ambassadors.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    setTimeout(function () {
	      _this2.setState({
	        defaultStyle: {
	          transition: "opacity " + duration + "ms ease-in-out",
	          opacity: 1
	        }
	      });
	    }, 500);
	  };
	
	  ambassadors.prototype.render = function render() {
	    var _state = this.state,
	        defaultStyle = _state.defaultStyle,
	        isShow = _state.isShow;
	    var location = this.props.location;
	
	    return _react2.default.createElement(
	      _contentPage2.default,
	      null,
	      _react2.default.createElement(_meta2.default, {
	        title: "Winpe | Diversity is Now | Ambassadors",
	        description: "View profiles of the Winpe Ambassadors- integral driving forces for Winpe initiatives, championing diversity from different external vantage points.",
	        location: location
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "section__content", style: defaultStyle },
	        _react2.default.createElement(
	          "div",
	          { className: "volunteer_wrapper" },
	          _react2.default.createElement(
	            "div",
	            { className: "volunteer_section" },
	            _react2.default.createElement(
	              "div",
	              { className: "back_page" },
	              _react2.default.createElement(
	                "div",
	                { className: "back_arrow" },
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: "/home/" },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fa fa-arrow-left" },
	                    " Back"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement("div", { className: "low__heading" }),
	            _react2.default.createElement(
	              "div",
	              { className: "" },
	              _react2.default.createElement(_Heading2.default, { title: "Winpe Ambassadors" })
	            ),
	            _react2.default.createElement(
	              _reactAnimateOnScroll2.default,
	              {
	                delay: 0,
	                duration: 2,
	                animateIn: "slideInRight",
	                offset: 600
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "v_team_section" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "row justify-content-center" },
	                  _team_constants.ambassadors_team_current.map(function (item, v) {
	                    return _react2.default.createElement(
	                      "div",
	                      { className: "col-md-4 col-sm-6 col-xs-12", key: v },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "v_card" },
	                        _react2.default.createElement(
	                          "div",
	                          null,
	                          _react2.default.createElement(
	                            "div",
	                            { className: "v_img" },
	                            _react2.default.createElement("img", {
	                              src: item.imgUrl,
	                              alt: item.name,
	                              className: "img-responsive",
	                              style: { width: '45%', height: '45%', borderRadius: '100%' }
	                            })
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "v_name" },
	                            item.name
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "v_post" },
	                            item.designation
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "v_post" },
	                            item.company
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "social_link" },
	                          _react2.default.createElement(
	                            "a",
	                            {
	                              rel: "noopener noreferrer",
	                              href: item.link,
	                              target: "_blank",
	                              className: ""
	                            },
	                            _react2.default.createElement("i", { className: "fa fa-linkedin" })
	                          )
	                        )
	                      )
	                    );
	                  })
	                ),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("br", null)
	              )
	            )
	          ),
	          _react2.default.createElement(TeamModal, {
	            show: isShow,
	            onHide: this.togglePopUp,
	            activeItem: this.state.activeItem
	          })
	        )
	      )
	    );
	  };
	
	  return ambassadors;
	}(_react2.default.Component);
	
	ambassadors.propTypes = {
	  location: _propTypes2.default.object
	};
	
	exports.default = ambassadors;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-ambassadors-index-js-67a0b1fdd6b74024b121.js